import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import { unit } from 'mathjs';
import { fetchUserObject } from 'actions';
import { GenericObject, User } from 'v2/models';

const CheckUserStatus = () => {
  const user: User = useSelector((state: GenericObject) => state.user.user);
  const dispatch = useDispatch();

  const debounceFetchUser = useCallback(
    debounce(() => {
      dispatch(fetchUserObject());
    }, unit('15s').toNumber('ms')),
    [dispatch]
  );

  useEffect(() => {
    if (user.waitlisted) {
      debounceFetchUser();
    }

    return () => {
      debounceFetchUser.cancel();
    };
  }, [user]);

  return null;
};

export default CheckUserStatus;
